import { createAsyncThunk } from '@reduxjs/toolkit'
import Web3 from 'web3'
import BoxyCatNFT from '../../../constants/abis/boxycats.json'
import { AbiItem } from 'web3-utils'

const CONTRACT_ADDRESS = '0x787324Dfea1C27b9d23835d962f7D80512334208'

export const fetchBoxycats = createAsyncThunk('boxycats/fetchall', async (account: string) => {
  const web3 = new Web3(Web3.givenProvider)

  const boxyCatNFT = new web3.eth.Contract(BoxyCatNFT as AbiItem[], CONTRACT_ADDRESS)
  const userBalance = await boxyCatNFT.methods.balanceOf(account).call()

  const tokens: string[] = []

  for (let i = 0; i < userBalance; i++) {
    const tokenId = await boxyCatNFT.methods.tokenOfOwnerByIndex(account, i).call()
    tokens.push(tokenId)
  }

  return { tokens }
})
